import { useGetTwilioSMSDetails } from '@hakimo-ui/hakimo/data-access';
import { QueryResult } from '@hakimo-ui/hakimo/ui-elements';
import { Label } from '@hakimo-ui/shared/ui-base';
import { InlineSMSMessage } from './InlineSMSMessage';
import { getSMSStatusLabelType } from './utils';

interface Props {
  twilioSsid: string;
  twilioCallingToName?: string;
  userName?: string;
  s3Urls?: string[];
}

export const TwilioSMSDetails = (props: Props) => {
  const { twilioSsid, twilioCallingToName, userName, s3Urls } = props;
  const query = useGetTwilioSMSDetails(twilioSsid);

  return (
    <div>
      <QueryResult queryResult={query} loadingText="Loading SMS details">
        {(data) => (
          <div>
            <div className="flex flex-wrap items-center gap-2">
              <span>
                {userName ? `${userName} sent an SMS to ` : 'SMS was sent to '}
                {twilioCallingToName
                  ? `${twilioCallingToName}(${data.smsTo || '-'})`
                  : data.smsTo || '-'}
              </span>
              {data.smsStatus && (
                <Label type={getSMSStatusLabelType(data.smsStatus)} small>
                  {data.smsStatus.charAt(0).toUpperCase() +
                    data.smsStatus.slice(1)}
                </Label>
              )}
            </div>
            {(data.smsBody || (s3Urls && s3Urls.length > 0)) && (
              <InlineSMSMessage message={data.smsBody} s3Urls={s3Urls} />
            )}
          </div>
        )}
      </QueryResult>
    </div>
  );
};

export const getSMSDetailsNode = (
  ssid: string,
  twilioCallingToName?: string,
  userName?: string,
  s3Urls?: string[]
) => {
  return (
    <TwilioSMSDetails
      twilioSsid={ssid}
      twilioCallingToName={twilioCallingToName}
      userName={userName}
      s3Urls={s3Urls}
    />
  );
};
